module.exports = __webpack_public_path__ + "img/radio.95fe19b6.svg";